import { tokens } from "@fluentui/react-components";
import { bundleIcon, Search20Filled, Search20Regular } from "@fluentui/react-icons";
import React from "react";
import { IconButton } from "./IconButton";

type Props = {
  isSelected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
};

const CombinedIcon = bundleIcon(Search20Filled, Search20Regular);

export const SearchButton: React.FC<Props> = ({ style, ...props }) => {
  const defaultStyle: React.CSSProperties = {
    position: "fixed",
    top: tokens.spacingVerticalXL,
    right: 0,
    width: "32px",
    height: "32px",
    borderRadius: `${tokens.borderRadiusMedium} 0 0 ${tokens.borderRadiusMedium}`,
    borderColor: tokens.colorNeutralStroke3,
    backgroundColor: tokens.colorNeutralBackground2,
    boxShadow: tokens.shadow4,
    ...style,
  };

  return <IconButton {...props} icon={<CombinedIcon />} style={defaultStyle} />;
};
